module.exports = __webpack_public_path__ + "VIPV14.png?547b38043a8c76be5a93a6275869e43e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV14.png
// module id = 108
// module chunks = 0